export type VideoItem = {
  id: string;
  kind?: "video" | "image" | "novel";
  title: string;
  description: string;
  creator: string;
  category: string;
  cover: string;
  src?: string;
  likes: number;
  comments: number;
  saves: number;
  collection: string;
  episode: number;
  duration: string;
  demo?: boolean;
  own?: boolean;
  private?: boolean;
  allowComments?: boolean;
  remote?: boolean;
  episodeCount?: number;
  episodes?: EpisodeItem[];
  actors?: string;
  detailLoaded?: boolean;
  labels?: string[];
  properties?: string[];
};
export type EpisodeItem = {
  id?: string;
  number: number;
  title: string;
  duration: string;
  cover: string;
  src?: string;
};
export const videos: VideoItem[] = [
  {
    id: "city-12",
    title: "久别重逢",
    description:
      "有些城市，去过会和某个人重逢。在熙攘的人海里，藏着最温柔的答案。",
    creator: "光影放映室",
    category: "影视解说",
    cover: "/media/night-portrait.jpg",
    likes: 23700,
    comments: 328,
    saves: 12000,
    collection: "城市故事",
    episode: 12,
    duration: "08:36",
  },
  {
    id: "travel-6",
    title: "下一站，未知的风景",
    description:
      "把日子交给山川湖海，去看看更大的世界。今天的目的地，是你心里的远方。",
    creator: "林间晚风",
    category: "旅行",
    cover: "/media/lake.jpg",
    likes: 18600,
    comments: 126,
    saves: 3600,
    collection: "旅行日记",
    episode: 6,
    duration: "04:12",
    own: true,
  },
  {
    id: "life-3",
    title: "慢下来，听见生活",
    description: "一朵花开的时间，也值得好好记录。自然影像播放示例。",
    creator: "生活观察员",
    category: "生活",
    cover: "/media/flower.jpg",
    src: "/media/demo.mp4",
    likes: 4200,
    comments: 56,
    saves: 820,
    collection: "生活切片",
    episode: 3,
    duration: "00:05",
    demo: true,
  },
  {
    id: "city-14",
    title: "灯火依旧",
    description: "天色暗下来以后，城市开始讲述另一个故事。#城市故事 #光影",
    creator: "光影放映室",
    category: "影视解说",
    cover: "/media/city.jpg",
    likes: 28000,
    comments: 342,
    saves: 861,
    collection: "城市故事",
    episode: 14,
    duration: "09:17",
  },
  {
    id: "city-11",
    title: "告别的车站",
    description: "告别是为了下一次更好的相遇。第11集 · 告别的车站。",
    creator: "光影放映室",
    category: "影视解说",
    cover: "/media/city.jpg",
    likes: 12600,
    comments: 67,
    saves: 382,
    collection: "城市故事",
    episode: 11,
    duration: "08:24",
  },
  {
    id: "city-13",
    title: "新的旅程",
    description: "旅程的意义，是重新找到自己。第13集 · 新的旅程。",
    creator: "光影放映室",
    category: "影视解说",
    cover: "/media/night-portrait.jpg",
    likes: 15300,
    comments: 92,
    saves: 492,
    collection: "城市故事",
    episode: 13,
    duration: "07:52",
  },
];
export const categories = [
  "影视解说",
  "短剧",
  "旅行",
  "生活",
  "美食",
  "音乐",
  "搞笑",
  "游戏",
  "知识",
  "科技",
  "运动",
  "萌宠",
];
export const episodes = [
  {
    number: 11,
    title: "告别的车站",
    duration: "08:24",
    cover: "/media/city.jpg",
  },
  {
    number: 12,
    title: "久别重逢",
    duration: "08:36",
    cover: "/media/night-portrait.jpg",
  },
  {
    number: 13,
    title: "新的旅程",
    duration: "07:52",
    cover: "/media/lake.jpg",
  },
  {
    number: 14,
    title: "灯火依旧",
    duration: "09:17",
    cover: "/media/city.jpg",
  },
];
export type Comment = {
  id: string;
  user: string;
  text: string;
  time: string;
  liked?: boolean;
  likes: number;
  reply?: string;
};
export const seedComments: Comment[] = [
  {
    id: "c1",
    user: "橙子汽水",
    text: "这座城市的晚风，总让人想起一些温柔的事。",
    time: "昨天 18:24",
    likes: 236,
    reply: "光影放映室：有空一定要去看看～",
  },
  {
    id: "c2",
    user: "晚风",
    text: "每一次出发，都是为了更好的相遇。",
    time: "2天前",
    likes: 189,
  },
  {
    id: "c3",
    user: "路过人间",
    text: "谢谢你好好记录生活 ❤️",
    time: "3天前",
    likes: 32,
  },
  {
    id: "c4",
    user: "小鹿同学",
    text: "音乐一响，晚风就下来了…",
    time: "3天前",
    likes: 98,
  },
];
export const formatCount = (n: number) =>
  n >= 10000 ? `${(n / 10000).toFixed(1)}万` : String(n);
export function filterVideos(items: VideoItem[], category: string, query = "") {
  return items.filter(
    (v) =>
      (category === "全部推荐" ||
        v.category === category ||
        v.labels?.includes(category)) &&
      `${v.title}${v.description}${v.creator}${v.collection}${v.actors || ""}`
        .toLowerCase()
        .includes(query.trim().toLowerCase()),
  );
}
